__turbopack_context__.v({
  "collapseItem": "detail_table-module-scss-module__z7OUHq__collapseItem",
  "container": "detail_table-module-scss-module__z7OUHq__container",
  "containerCollapse": "detail_table-module-scss-module__z7OUHq__containerCollapse",
  "containerTitle": "detail_table-module-scss-module__z7OUHq__containerTitle",
  "containerTitleWrap": "detail_table-module-scss-module__z7OUHq__containerTitleWrap",
  "itemEmpty": "detail_table-module-scss-module__z7OUHq__itemEmpty",
  "itemTable": "detail_table-module-scss-module__z7OUHq__itemTable",
});
